module.exports = __webpack_public_path__ + "img/noq-map-pin-active.cbfb352b.svg";